













import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
class roundItem extends Vue {
  tagGroupList: any[] = [];
  roundList: any[] = [];

  @Prop()
  round;

  // 是否当做筛选项选中
  // true: 在项目详情页中展示的样式,默认字体为蓝色,不带日期
  // false: 在编辑轮次中展示的样式,默认字体为蓝色,修改后为红色,带日期
  @Prop()
  canSelect;

  // 是否为保密(加上保密期图标)
  @Prop()
  isSecret;

  // 是否为修改后(红色字体展示)
  @Prop()
  isChange;

  // 是否为被选中(黑色字体展示)
  @Prop()
  isSelected;

  mounted() {}
}
export default roundItem;
